/* eslint-disable */
export default {
  tollFree: 'Chamada gratuita',
  rcvPmiMeetingTitle: 'Reunião por vídeo de {extensionName}',
} as const;

// @key: @#@"tollFree"@#@ @source: @#@"Toll-Free"@#@
// @key: @#@"rcvPmiMeetingTitle"@#@ @source: @#@"{extensionName}'s video meeting"@#@
